export default __webpack_public_path__ + "static/media/OTEL_Customer-Story-Telecomms-Comp.264a27e1.jpg";